import { FC } from 'react';
import NoteDone from '../../../../src/assets/image/icons/note-done.svg';
import { NewsCardPropTypes } from './types/propTypes';
import styles from './NewsCard.module.scss';

const NewsCard: FC<NewsCardPropTypes> = (props: NewsCardPropTypes) => {
  const {
   data
  } = props;
  


  return (
    <div className={styles['container']}>
      <div className={styles['upper-container']}>
        <div  className={styles['image-container']}><img className={styles['image']} width={'16px'} height={'16px'} src={NoteDone} alt={'note-done'}/></div>
        <div className={styles['title']}>{data.title}</div>
      </div>
      {data.rich_text_description ? <div className={styles['description']} dangerouslySetInnerHTML={{ __html: data.rich_text_description }} /> : <div className={styles['description']}>{data.description}</div>}
    </div>
  );
};

export default NewsCard;
export type { NewsCardPropTypes };
